import { useSnackbar } from 'notistack';
import { CLIENT_ID } from 'shared/constants';
import { useService } from 'shared/providers';
import { useAuthState } from 'shared/stores';

export function useAnalyticsAppInfo() {
    const {
        eventService,
        authService,
        powerBiService,
        appConfig: { appId },
    } = useService();
    const authState = useAuthState();
    const user = authState.user.get();
    const { enqueueSnackbar } = useSnackbar();

    const prerequisites = {
        services: {
            eventService,
            authService,
            pbiService: powerBiService,
        },
        appInfo: {
            applicationId: appId,
            clientId: CLIENT_ID,
            userId: user?.id || '',
            appName: 'Paragon PMT',
        },
    };
    const options = {
        snackbar: {
            enqueueSnackbar,
        },
    };
    return {
        prerequisites,
        options,
    };
}
